import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_fc40a26d-7ee2-4b99-ac23-dd0e9435603a/artifacts/9ey7cuwh_logo.png";

const NAV = [
  { label: "Le logement", href: "#produit" },
  { label: "Usages", href: "#usages" },
  { label: "Avantages", href: "#avantages" },
  { label: "Showroom", href: "#showroom" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className="yono-header"
      data-testid="site-header"
      style={{
        boxShadow: scrolled ? "0 1px 0 var(--yono-border)" : "none",
      }}
    >
      <div className="container-yono flex items-center justify-between h-[120px] lg:h-[140px]">
        <a
          href="#top"
          className="flex items-center"
          data-testid="header-logo-link"
        >
          <img
            src={LOGO_URL}
            alt="YONO"
            className="h-20 lg:h-24 w-auto"
            style={{ objectFit: "contain" }}
          />
        </a>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="text-[12px] tracking-[0.14em] uppercase text-[var(--yono-soft-black)] hover:text-[var(--yono-wood)] transition-colors"
              data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:block">
          <a href="#contact" className="btn-primary" data-testid="header-cta">
            Demander une étude
          </a>
        </div>

        <button
          className="lg:hidden p-2 -mr-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          data-testid="header-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-[var(--yono-border)] bg-[var(--yono-off-white)]"
          data-testid="header-mobile-menu"
        >
          <div className="container-yono py-6 flex flex-col gap-5">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-[13px] tracking-[0.14em] uppercase text-[var(--yono-soft-black)]"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              className="btn-primary mt-2 justify-center"
              data-testid="header-mobile-cta"
            >
              Demander une étude
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
